export const NOT_LOGGED_IN_FEATURE_FLAG_TARGET = 'not-logged-in';

export const buildFeatureFlagContext = (organizationId, userId) => {
  const targetingKey = organizationId || NOT_LOGGED_IN_FEATURE_FLAG_TARGET;

  return {
    targetingKey,
    org_id: targetingKey,
    user_id: userId || NOT_LOGGED_IN_FEATURE_FLAG_TARGET
  };
};
